module.exports = __webpack_public_path__ + "static/rider-small-f6244c93909d26e171de454b51208bb0.gif";